export enum TOOLTIP_PLACEMENT {
  TOP = "top",
  BOTTOM = "bottom",
  LEFT = "left",
  RIGHT = "right",
}

export enum TOOLTIP_THEME {
  LIGHT = "light",
  DARK = "dark",
}

export const tooltipPositionClassNamesByPlacement = {
  [TOOLTIP_PLACEMENT.TOP]: "bottom-full left-1/2 -translate-x-1/2",
  [TOOLTIP_PLACEMENT.BOTTOM]: "top-full left-1/2 -translate-x-1/2",
  [TOOLTIP_PLACEMENT.LEFT]: "right-full top-1/2 -translate-y-1/2",
  [TOOLTIP_PLACEMENT.RIGHT]: "left-full top-1/2 -translate-y-1/2",
};

export const tooltipPositionWithArrowClassNamesByPlacement = {
  [TOOLTIP_PLACEMENT.TOP]: "bottom-[calc(100%+0.75rem)]",
  [TOOLTIP_PLACEMENT.BOTTOM]: "top-[calc(100%+0.75rem)]",
  [TOOLTIP_PLACEMENT.LEFT]: "right-[calc(100%+0.75rem)]",
  [TOOLTIP_PLACEMENT.RIGHT]: "left-[calc(100%+0.75rem)]",
};

export const tooltipArrowClassNamesByPlacement = {
  [TOOLTIP_PLACEMENT.TOP]:
    'before:content-[""] before:absolute before:top-full before:left-1/2 before:-translate-x-1/2 before:border-r-8 before:border-r-transparent before:border-l-8 before:border-l-transparent before:border-t-8',
  [TOOLTIP_PLACEMENT.BOTTOM]:
    'before:content-[""] before:absolute before:bottom-full before:left-1/2 before:-translate-x-1/2 before:border-r-8 before:border-r-transparent before:border-l-8 before:border-l-transparent before:border-b-8',
  [TOOLTIP_PLACEMENT.LEFT]:
    'before:content-[""] before:absolute before:left-full before:top-1/2 before:-translate-y-1/2 before:border-t-8 before:border-t-transparent before:border-b-8 before:border-b-transparent before:border-l-8',
  [TOOLTIP_PLACEMENT.RIGHT]:
    'before:content-[""] before:absolute before:right-full before:top-1/2 before:-translate-y-1/2 before:border-t-8 before:border-t-transparent before:border-b-8 before:border-b-transparent before:border-r-8',
};

export const tooltipThemeColorClassNamesByTheme = {
  [TOOLTIP_THEME.DARK]: "bg-[#1F2A37] text-white before:border-[#1F2A37]",
  [TOOLTIP_THEME.LIGHT]: "bg-[#F4F4F5] text-[#52525B] before:border-[#F4F4F5]",
};
